import { useCurrentUser } from 'hooks/useCurrentUser';
import { useValidateUserHasRbacPermissions } from 'hooks/useValidateUserHasRbacPermissions';

export const QC_PERMISSION = 'Worklist Quality Control Workflow';

export const useHasQualityControlPermission = (): boolean => {
  const { data } = useCurrentUser();

  const permission = useValidateUserHasRbacPermissions({
    permissionNames: [QC_PERMISSION],
    component: 'Worklist',
  });

  return data ? permission : false;
};
